exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = require('stream');
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');



/*****************
 ** WEBPACK FOOTER
 ** ./~/node-libs-browser/~/readable-stream/readable.js
 ** module id = 363
 ** module chunks = 0
 **/